// src/assets/hero ve src/assets/screens klasorlerindeki gorselleri
// derleme aninda otomatik toplar. Yeni foto eklemek icin klasore dosya
// atmak yeterli; burada kod degistirmek gerekmez.
// Sira dosya adina gore alfabetiktir, bu yuzden 01-, 02- on eki kullanin.

function loadImages(context) {
  return context
    .keys()
    .sort()
    .map((key) => {
      const mod = context(key);
      return {
        src: mod.default || mod,
        name: key.replace(/^\.\//, '').replace(/\.[^.]+$/, ''),
      };
    });
}

export const heroImages = loadImages(
  require.context('../assets/hero', false, /\.(jpe?g|png|webp)$/i)
);

export const screenshots = loadImages(
  require.context('../assets/screens', false, /\.(jpe?g|png|webp)$/i)
);
